import React, {useEffect, useRef, useState} from "react";
import {
  View,
  Text,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  Animated,
  Easing,
} from "react-native";
import {Color, globalFontStyle, globalStyle} from "../../assets";
import Width from "../../assets/Width";
import FastImage from "../../common/FastImage";
import {globalImport} from "../../common/globalImports";
import {Button} from "../../components/core/Button";
import {
  cross_white_black,
  down_arrow,
  up_arrow,
  wallet_success,
} from "../../utils/images";
import {useNavigation} from "@react-navigation/native";
import {useDispatch, useSelector} from "react-redux";
import Colors from "../../assets/Color/Colors";
import i18n from "i18next";
import AsyncStorage from "@react-native-async-storage/async-storage";
import Toast from "react-native-toast-message";
import {Network} from "../../utils/network";
import {globalConfigurableData, globalConst} from "../../utils/globalConstant";
import {countryRegion, isMobile} from "../../utils/commonMethods";
import {convert} from "../../locale/translateText";
import {getConfig} from "../../utils/commonredux/commonRedux.action";

const LanguageSelection = ({firstTimeLogin, onFinalFormAccept}) => {
  let navigation = useNavigation();
  const dispatch = useDispatch();
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [showProfileDetials, setShowProfileDetails] = useState(false);
  const ref = useRef(null);
  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );
  const language = globalConfigData?.supportedLocales ?? [];
  const [contentHeight, setContentHeight] = useState(0);
  const animatedHeight = useRef(new Animated.Value(0)).current;

  const onLanguagePress = languageData => {
    setSelectedLanguage(languageData);
  };

  const onPageClose = () => {
    if (firstTimeLogin) {
      onFinalFormAccept(true);
    } else {
      if (isMobile()) {
        navigation.navigate("Home");
      } else {
        navigation.pop(1);
      }
    }
  };

  const onChangeLanguage = async () => {
    if (selectedLanguage?.key) {
      if (globalImport.isWeb) {
        localStorage.setItem("lang", selectedLanguage?.key);
      } else {
        await AsyncStorage.setItem("lang", selectedLanguage?.key);
      }
      await i18n.changeLanguage(selectedLanguage?.key);
      if (firstTimeLogin) {
        onFinalFormAccept(true, selectedLanguage?.key);
      } else {
        const formData = new FormData();
        formData.append("preferred_locale", selectedLanguage?.key);
        const config = {
          headers: {
            "content-type": "multipart/form-data",
            type: "formData",
          },
        };
        await Network.updateUserDetails(formData, config);
      }
      dispatch(getConfig());
      onPageClose();
      Toast.show({
        type: "info",
        text1: convert("Language changed successfully"),
        visibilityTime: 2000,
        position: "bottom",
      });
    } else {
      Toast.show({
        type: "error",
        text1: convert("Please select a language"),
        visibilityTime: 2000,
        position: "bottom",
      });
    }
  };

  const toggleDetails = () => {
    const toValue = !showProfileDetials ? 1 : 0;
    setShowProfileDetails(!showProfileDetials);

    Animated.timing(animatedHeight, {
      toValue,
      duration: 300,
      easing: Easing.bezier(0.4, 0, 0.2, 1),
      useNativeDriver: false,
    }).start();
  };

  return (
    <SafeAreaView style={[globalStyle.pageContainer, {flexGrow: 1}]} ref={ref}>
      <View style={{flexGrow: 1}}>
        {isMobile() ? (
          <>
            <TouchableOpacity
              style={{paddingVertical: 13, paddingHorizontal: 16}}
              onPress={onPageClose}>
              <FastImage
                style={{width: 30, height: 30}}
                source={globalConfigurableData.back_arrow()}
              />
            </TouchableOpacity>

            <ScrollView
              contentContainerStyle={{
                flexGrow: 1, 
                paddingVertical: 15, 
                paddingHorizontal: 16,
                paddingBottom: 80
              }}
              keyboardShouldPersistTaps="handled"
              nestedScrollEnabled={true}>
              <Text style={styles.text_card_img_title}>
                Chose your preferred language
              </Text>
              <Text
                style={{...styles.text_card_img_subtitle, marginBottom: 20}}>
                You can always change your language from accounts section
              </Text>

              {language?.map(lanugageItems => {
                const selected = selectedLanguage?.key
                  ? lanugageItems?.key === selectedLanguage?.key
                  : lanugageItems?.key === i18n?.language;
                if (!i18n.options.resources[lanugageItems?.key]) {
                  return null;
                }
                return (
                  <TouchableOpacity
                    key={lanugageItems?.label}
                    onPress={() => {
                      onLanguagePress(lanugageItems);
                    }}
                    style={styles.text_card_blk_account}>
                    <View
                      style={{
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        paddingLeft: 0,
                        flex: 1,
                      }}>
                      <Text style={styles.text_card_img_title}>
                        {lanugageItems?.labelTranslated}
                      </Text>
                      <Text style={styles.text_card_img_subtitle}>
                        {lanugageItems?.label}
                      </Text>
                    </View>

                    {selected ? (
                      <FastImage
                        style={{width: 30, height: 30}}
                        source={wallet_success()}
                      />
                    ) : null}
                  </TouchableOpacity>
                );
              })}
            </ScrollView>
            <View
              style={[
                globalStyle.bottomAbsBtnBar,
                {
                  paddingHorizontal: 16,
                  paddingBottom: 16,
                  width: '100%',
                  backgroundColor: Colors.bgWhite,
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0
                }
              ]}>
              <Button
                variant="primary"
                onPress={() => {
                  setTimeout(() => {
                    onChangeLanguage();
                  }, globalConst?.buttonTimer);
                }}
                translate={true}
                style={{width: '100%'}}
              >
                Proceed
              </Button>
            </View>
          </>
        ) : (
          <View style={styles.eventDetailsBox}>
            <TouchableOpacity
              onPress={toggleDetails}
              activeOpacity={0.7}>
              <View style={styles.eventDetailTitle}>
                <View style={{flex: 1}}>
                  <Text
                    style={{
                      ...globalFontStyle.appFontSubTextBold,
                      color: globalConfigurableData.primaryTextColor1,
                      fontSize: 14,
                      lineHeight: 14,
                    }}>
                    Choose your preferred language
                  </Text>
                  <Text
                    style={{
                      ...globalFontStyle.appFontSmallText,
                      color: Colors.grey7,
                      marginTop: 4,
                    }}>
                    You can always change your language from accounts section
                  </Text>
                </View>
                <Animated.View style={{
                  transform: [{
                    rotate: animatedHeight.interpolate({
                      inputRange: [0, 1],
                      outputRange: ['0deg', '180deg']
                    })
                  }]
                }}>
                  <FastImage
                    source={down_arrow()}
                    style={{width: 18, height: 18}}
                  />
                </Animated.View>
              </View>
            </TouchableOpacity>

            <Animated.View style={{
              height: animatedHeight.interpolate({
                inputRange: [0, 1],
                outputRange: [0, contentHeight]
              }),
              opacity: animatedHeight.interpolate({
                inputRange: [0, 1],
                outputRange: [0, 1]
              }),
              overflow: 'hidden'
            }}>
              <View
                onLayout={(event) => {
                  const {height} = event.nativeEvent.layout;
                  setContentHeight(height);
                }}
                style={styles.contentContainer}>
                {language?.map(lanugageItems => {
                  const selected = selectedLanguage?.key
                    ? lanugageItems?.key === selectedLanguage?.key
                    : lanugageItems?.key === i18n?.language;
                  if (!i18n.options.resources[lanugageItems?.key]) {
                    return null;
                  }
                  return (
                    <TouchableOpacity
                      key={lanugageItems?.label}
                      onPress={() => {
                        onLanguagePress(lanugageItems);
                      }}
                      style={styles.text_card_blk_account}>
                      <View
                        style={{
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          paddingLeft: 0,
                          flex: 1,
                        }}>
                        <Text style={styles.text_card_img_title}>
                          {lanugageItems?.labelTranslated}
                        </Text>
                        <Text style={styles.text_card_img_subtitle}>
                          {lanugageItems?.label}
                        </Text>
                      </View>

                      {selected ? (
                        <FastImage
                          style={{width: 30, height: 30}}
                          source={wallet_success()}
                        />
                      ) : null}
                    </TouchableOpacity>
                  );
                })}
                <Button
                  variant="primary"
                  onPress={() => {
                    setTimeout(() => {
                      onChangeLanguage();
                    }, globalConst?.buttonTimer);
                  }}
                  translate={true}
                  style={{marginTop: 15}}
                >
                  Proceed
                </Button>
              </View>
            </Animated.View>
          </View>
        )}
      </View>
    </SafeAreaView>
  );
};

export default LanguageSelection;

const styles = StyleSheet.create({
  text_card_img_title: {
    ...globalFontStyle.appFontBody,
    color: globalConfigurableData.primaryTextColor1,
    fontSize: 14,
    marginBottom: 4,
  },
  text_card_img_subtitle: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.grey7,
  },
  text_card_blk_account: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: globalConfigurableData.borderColor,
  },

  eventDetailsBox: {
    marginTop: 12,
    shadowColor: "#666",
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.05,
    shadowRadius: 1,
    elevation: 1,
    backgroundColor: Colors.bgWhite,
    marginHorizontal: 16,
  },
  eventDetailTitle: {
    height: 48,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: 'center',
    paddingHorizontal: 16,
  },
  contentContainer: {
    paddingTop: 8,
    paddingHorizontal: 16,
  },
});
